import { Link } from 'react-router-dom'

interface Props {
  links: { [key: string]: string }
}

export function NavLinks({ links }: Props) {
  return (
    <nav className={tailwind.navigation}>
      <div className={tailwind.linkContainer}>
        {Object.keys(links).map((key, index) => (
          <Link key={index} to={links[key]} replace className={tailwind.link}>
            {key}
          </Link>
        ))}
      </div>
    </nav>
  )
}

const tailwind = {
  navigation: 'flex justify-between bg-white p-1 mr-10',
  linkContainer: 'text-sm lg:flex-grow',
  link: 'text-xl block mt-4 lg:inline-block lg:mt-0 ml-8 text-blue-500 hover:text-blue-800 no-underline',
}
